import { TravelerPickerContextType } from "./types";

export const DEFAULT_TRAVELER_PICKER_CONTEXT: TravelerPickerContextType = {
  recentPickerDataPassenger: [],
  travelers: [],
  divisions: [],
};
